export var EOpportunityType;
(function (EOpportunityType) {
    EOpportunityType["INVESTMENT_OPPORTUNITY"] = "INVESTMENT_OPPORTUNITY";
    EOpportunityType["ADVISORY"] = "ADVISORY";
    EOpportunityType["INSURANCE"] = "INSURANCE";
    EOpportunityType["FINANCIAL_SOLUTIONS"] = "FINANCIAL_SOLUTIONS";
    EOpportunityType["OTHER"] = "OTHER";
})(EOpportunityType || (EOpportunityType = {}));
